import { PerspectiveCamera } from '@react-three/drei';
import { RigidBody } from '@react-three/rapier';
import { useSimulationContext } from '../../providers/SimulationProvider';

function SceneCamera() {
  const { characterGlb } = useSimulationContext();
  const localZ = (characterGlb?.zoom ?? 6) - 1;

  return (
    <>
      <RigidBody
        canSleep={false}
        colliders={false}
        mass={1}
        type='dynamic'
        position={[0.075, 2, 1]}
        enabledRotations={[false, false, false]}
      >
        <PerspectiveCamera makeDefault fov={5} position={[0, -0.4, localZ]} />
      </RigidBody>
    </>
  );
}

export default SceneCamera;
